module.exports = __webpack_public_path__ + "static/media/vendor_management_filter_active_icon.060c1dff.svg";